import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { setAssessReduce } from "src/store/reducers/fulfillDetailReduce";
import SVG from "src/utils/SVG";
import styled from "styled-components";
import Button from "../common/Button";

interface IScoreProps {
  id?: string;
  value?: string | ReadonlyArray<string> | number | undefined;
  star?: number;
}

const ScoreRegisterBox = (props: IScoreProps) => {
  const dispatch = useDispatch();
  const [clicked, setClicked] = useState(props.star || 0);
  const [starValue, setStarValue] = useState([false, false, false, false, false]);
  const [contents, setContents] = useState(props.value ? props.value : "");
  const starArray = [1, 2, 3, 4, 5];

  useEffect(() => {
    const prevStarValue = [...starValue];
    if (props.star !== 0) {
      prevStarValue.fill(true, 0, clicked);
    }
    setStarValue(prevStarValue);
  }, []);

  useEffect(() => {
    // 변경했을때 store에 값 저장하기
    dispatch(
      setAssessReduce({
        score: clicked,
        star: starValue,
        comment: contents,
      }),
    );
  }, [clicked, starValue, contents]);

  const setStar = (e: React.MouseEvent<HTMLSpanElement>) => {
    const star: any = Number(e.currentTarget.dataset.value);
    const selecedStar = star - 1;
    const clickedStar = starValue[selecedStar];
    const tempStarValue = [...starValue];

    if (clickedStar) {
      // true : 선택된 별점 밖에 점수 클릭
      if (clicked === 1) {
        setClicked(0);
        tempStarValue.fill(false, 0, starArray.length);
      } else {
        setClicked(star);
        tempStarValue.fill(false, star, starArray.length);
      }
    } else {
      // false : 선택된 별점 밖에 점수 클릭
      setClicked(star);
      tempStarValue.fill(true, 0, star);
    }

    setStarValue(tempStarValue);
  };

  const setScoreReset = () => {
    setClicked(0);
    setStarValue([false, false, false, false, false]);
  };

  const handleSetValue = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    setContents(e.target.value);
  };

  const checkIsActive = (star: number) => {
    if (starValue[star - 1]) {
      return "bigStarActive";
    }

    return "bigStar";
  };

  return (
    <ScoreDlBox>
      <div>
        <dt>
          별점
          <Button size="small" onClick={setScoreReset}>
            리셋
          </Button>
        </dt>
        <dd>
          <div className="star-wrap">
            {starArray.map((v, i) => {
              return (
                <span data-value={v} key={i} onClick={setStar}>
                  <SVG name={checkIsActive(v)} width={49} height={47} viewBox="0 0 49 47" />
                </span>
              );
            })}
          </div>
        </dd>
      </div>
      <div>
        <dt>코멘트</dt>
        <dd>
          <textarea value={contents} placeholder={"코멘트를 작성해주세요!"} onChange={(e) => handleSetValue(e)} id={props.id} />
        </dd>
      </div>
    </ScoreDlBox>
  );
};

const ScoreDlBox = styled.dl`
  padding: 0 15px;
  > div {
    ${({ theme }) => theme.flexBox.flexMixin("row", "flex-start", "flex-start")};
    &:first-child {
      dd {
        border-bottom: 1px solid ${({ theme }) => theme.color.linePrimary};
      }
    }
    &:last-child {
      dt {
        margin-top: 35px;
      }
    }
    dt {
      flex: 0 0 auto;
      width: 50px;
      margin-top: 24px;
      color: ${({ theme }) => theme.color.tertiary};
      font-weight: 500;
      > button {
        display: block;
        padding: 0;
        margin-top: 10px;
      }
    }
    dd {
      flex: 1 0 auto;
      padding: 24px 0;
      textarea {
        width: 100%;
        height: 160px;
        padding: 12px 20px;
        border: none;
        border-radius: 4px;
        background: ${({ theme }) => theme.color.bgPrimary};
        color: ${({ theme }) => theme.color.primary};
        font-size: 16px;
        line-height: 20px;
        resize: none;
        &::placeholder {
          color: ${({ theme }) => theme.color.tertiary};
          font-size: 14px;
        }
        &:focus {
          outline: none;
        }
      }
      .star-wrap {
        ${({ theme }) => theme.flexBox.inlineFlex("space-between", "center")}
        width: 100%;
      }
    }
  }
`;

export default ScoreRegisterBox;
